<template>
  <div>
    <Head title="Formulários" />
    <div class="shadow_box rounded-lg p-6">
      <div class="mb-6 flex flex-nowrap items-center">
        <h1 class="mr-3 text-2xl text-gray-777 font-roboto uppercase">Formulários</h1>
        <font-awesome-icon icon="fa-cog" class="text-gray-600 text-lg cursor-pointer" @click.pprevent="openModalConfig" />
      </div>
      <data-table
        v-if="loadTable"
        v-model:columns="columns"
        route="forms/list"
        no-data-label="Nenhum formulário cadastrado"
        no-result-label="Nenhum formulário encontrado"
      >
        <template #table.cell.content.form_show_first_login="{ value, row }">
          <switch-input v-model="row.show_first_login" labelChecked="Sim" labelUnchecked="Não" @click="changeShowFirstLogin(row)" />
        </template>
        <template #grid.content.body.form_show_first_login="{ value, row }">
            <switch-input v-model="row.show_first_login" labelChecked="Sim" labelUnchecked="Não" @click="changeShowFirstLogin(row)" />
        </template>

        <template #table.cell.content.actions="{ value, row }">
            <div class="inline-grid grid-cols-2 gap-4 ">
                <span @click="openModalEdit(row)"><font-awesome-icon icon="fa-pen-to-square" class="text-blue-500 text-lg cursor-pointer" /></span>
                <span @click="openModalConfirmDelete(row)"><font-awesome-icon icon="fa-trash-can" class="text-red-600 text-lg cursor-pointer" /></span>
            </div>
        </template>
        <template #grid.content.body.actions="{ value, row }">
            <div class="inline-grid grid-cols-2 gap-4 ">
                <span @click="openModalEdit(row)"><font-awesome-icon icon="fa-pen-to-square" class="text-blue-500 text-lg cursor-pointer" /></span>
                <span @click="openModalConfirmDelete(row)"><font-awesome-icon icon="fa-trash-can" class="text-red-600 text-lg cursor-pointer" /></span>
            </div>
        </template>
    
        <template #after.reload-button>
            <button class="flex items-end font-roboto font-medium btn-blue uppercase" @click.prevent="openModalEdit({})">
              <font-awesome-icon icon="fa-plus" class="text-white text-lg mr-0 lg:mr-2" /><span class="hidden lg:block"> Adicionar Formulário</span>
            </button>
        </template>
      </data-table>
    </div>
    <modal-delete ref="modalDelete" @confirm="reloadTable"></modal-delete>
    <modal-edit ref="modalEdit" title="Formulários" url="forms" :modal-scrollable="true" @submitForm="reloadTable">
      <template #form="{item}">
        <text-input v-model="item.name" :error="item.errors.name" class="lg:pr-6 w-full lg:w-4/6" label="Nome" />
        <!-- switch-input v-model="item.show_first_login" class="w-full mt-6 lg:mt-0" label="Exibe após primeiro acesso" labelChecked="Sim" labelUnchecked="Não" / -->
        <textarea-input v-model="item.description" :error="item.errors.description" class="mt-6 w-full" label="Descrição" />
        <button class="mt-6 flex items-end font-roboto font-medium btn-blue uppercase" @click.prevent="item.questions.push({type: null});">
          <font-awesome-icon icon="fa-plus" class="text-white text-lg mr-0 lg:mr-2" /> Adicionar Pergunta
        </button>
        <div class="w-full flex flex-wrap p-6 mt-4  bg-gray-100/50" v-for="(question, question_index) in item.questions">
          <text-input v-model="question.question" :error="item.errors[`questions.`+question_index+`.question`]" class="lg:pr-6 w-full lg:w-7/12" placeholder="Pergunta" />
          <select-input v-model="question.type" @change="onChangeQuestionType(question)" :error="item.errors[`questions.`+question_index+`.type`]" class="mt-6 lg:mt-0 w-5/6 lg:w-4/12" placeholder="Tipo de resposta">
            <option :value="null" disabled class="hidden invisible">Tipo de resposta</option>
            <option v-for="(value, name, index) in question_types" :key="name" :value="name">{{ value }}</option>
          </select-input>
          <div class="mt-6 lg:mt-0 w-1/6 lg:w-1/12 self-center text-right">
            <span @click="deleteQuestion(item, question)"><font-awesome-icon icon="fa-xmark" class="text-gray-600 text-lg cursor-pointer" /></span>
          </div>
          <div class="w-full flex flex-wrap" v-if="question.type == 'multipla_escolha' || question.type == 'caixa_selecao'">
            <button class="flex items-end font-roboto font-medium btn-blue uppercase text-xs px-3 py-2 mt-4 mb-3" @click.prevent="question.answers.push({});">
              <font-awesome-icon icon="fa-plus" class="text-white text-lg mr-0 lg:mr-2" /> Adicionar Resposta
            </button>
            <div class="w-full flex flex-wrap p-2 mt-1 bg-gray-100/75" v-for="(answer, answer_index) in question.answers">
              <text-input v-model="answer.answer" :error="item.errors[`questions.`+question_index+`.answers.`+answer_index+`.answer`]" class="lg:pr-6 w-full lg:w-7/12" placeholder="Resposta" />
              <mask-input mask="#####" v-model="answer.score" :error="item.errors[`questions.`+question_index+`.answers.`+answer_index+`.score`]" class="mt-6 lg:mt-0 w-5/6 lg:w-4/12" placeholder="Score" />
              <div class="mt-6 lg:mt-0 w-1/6 lg:w-1/12 self-center text-right">
                <span @click="deleteAnswer(question, answer)"><font-awesome-icon icon="fa-xmark" class="text-gray-600 text-lg cursor-pointer" /></span>
              </div>
            </div>
          </div>
        </div>
      </template>
    </modal-edit>
    <modal ref="modalConfig" size="modal-lg" :modal-scrollable="true">
        <template #header>
            <div class="text-gray-777 font-roboto uppercase">
                <span>Formulários - Configurações</span>
            </div>
        </template>
        <template #body>
          <form action="">
            Selecione os formulários que serão exibidos após o primeiro login:
            <div class="flex justify-center mt-4">
              <div class="w-1/3 m-2">
                Selecionados:
                <draggable class="list-group list-group-selected" itemKey="id" :list="formConfig.selected" group="forms">
                  <template #item="{element}">
                      <div class="list-group-item">
                        {{element.name}}
                        <input type="hidden" name="selected" :value="element.id">
                      </div>
                    </template>
                </draggable>
              </div>
              <div class="w-1/3 m-2">
                Não selecionados:
                <draggable class="list-group" itemKey="id" :list="formConfig.unselected" group="forms">
                    <template #item="{element}">
                      <div class="list-group-item">
                        {{element.name}}
                        <input type="hidden" name="unselected" :value="element.id">
                      </div>
                    </template>
                </draggable>
              </div>
            </div>
          </form>
        </template>
        <template #footer>
            <button type="button" class="px-6 py-2.5 bg-gray-600 text-white font-roboto font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-800 active:shadow-lg transition duration-150 ease-in-out" @click.prevent="closeModalConfig">Cancelar</button>
            <loading-button :loading="loadModalConfig" class="btn-blue px-6 py-2.5 text-xs leading-tight uppercase ml-1" @click.prevent="saveModalConfig" type="submit">Salvar</loading-button>
        </template>
    </modal>
  </div>
</template>

<script>
import { Head, useForm } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import ModalDelete from '@/Shared/ModalDelete'
import ModalEdit from '@/Shared/ModalEdit'
import SwitchInput from '@/Shared/SwitchInput'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import SelectInput from '@/Shared/SelectInput'
import DataTable from '@/Shared/DataTable'
import Modal from '@/Shared/Modal'
import draggable from 'vuedraggable'
import MaskInput from '@/Shared/MaskInput'

export default {
  props: {
    question_types: Object,
  },
  components: {
    Head,
    LoadingButton,
    ModalDelete,
    ModalEdit,
    SwitchInput,
    TextInput,
    TextareaInput,
    SelectInput,
    DataTable,
    Modal,
    draggable,
    MaskInput,
  },
  layout: Layout,
  data() {
    return {
      loadModalConfig: false,
      loadTable: true,
      formsSelected: [],
      formsUnselected: [],
      formConfig: {},
      columns: [
        {
          uniqid: 'form_name',
          label: 'Nome',
          field: 'name',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
        },
        {
          uniqid: 'form_description',
          label: 'Descrição',
          field: 'description',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => val ? val.substr(0, 50) : ''
        },
        {
          uniqid: 'form_show_first_login',
          label: 'Exibe após primeiro acesso',
          field: 'show_first_login',
          visible: false,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
        },
        {
          uniqid: 'actions',
          label: 'Ações',
          field: 'id',
          visible: true,
          align: 'center',
          classes: 'py-3 border-b',
          headerClass: 'p-4',
        },
      ],
    }
  },
  mounted() {
    this.loadOptions();
  },
  methods: {
    changeShowFirstLogin(item) {
      item.show_first_login = !item.show_first_login;
      this.$inertia.post("/forms/update-show-first-login", item);
    },
    openModalConfirmDelete(item) {
      this.$refs.modalDelete.openModalDelete(item, `/forms/${item.id}`, `Deseja realmente excluir o formulário ${item.name}?`);
    },
    openModalEdit(item) {
      this.$refs.modalEdit.openModalEdit({
        id: item.id,
        name: item.name,
        description: item.description,
        //show_first_login: item.show_first_login,
        questions: item.questions ?? [],
        errors: {
          questions: {}
        }
      });
    },
    reloadTable() {
      this.loadTable = false;
      this.loadOptions();
      setTimeout(() => this.loadTable = true, 10);
    },
    onChangeQuestionType(question) {
      question.answers = [];
    },
    deleteQuestion(form, question) {
      form.questions.splice(form.questions.indexOf(question), 1);
    },
    deleteAnswer(question, answer) {
      question.answers.splice(question.answers.indexOf(answer), 1);
    },
    openModalConfig() {
      this.formConfig = useForm({
        selected: [].concat(this.formsSelected),
        unselected: [].concat(this.formsUnselected),
      });
      this.$refs.modalConfig.showModal = true;
    },
    closeModalConfig() {
      this.$refs.modalConfig.showModal = false;
    },
    saveModalConfig() {
      this.formConfig.post(`/forms/update-config`, {
        onFinish: () => {
            if(!Object.keys(this.formConfig.errors).length) {
                this.closeModalConfig();
                this.loadOptions();
            } else {
                this.loadModalConfig = false;
            }
        }
      });
    },
    async loadOptions() {
      await fetch(
        `forms/get-options`
      ).then(res => {
        res.json().then(json => {
          this.formsSelected = json.formsSelected;
          this.formsUnselected = json.formsUnselected;
        });
      });
    },
  },
}
</script>
<style>
  .list-group {
    @apply flex flex-col;
  }

  .list-group-item {
    @apply text-white first:rounded-tl first:rounded-tr
    relative block py-3 px-9 border cursor-move bg-gray-600
    hover:bg-gray-700;
  }

  .list-group-selected .list-group-item {
    @apply bg-blue-600 
    hover:bg-blue-700;
  }
</style>